import { AppointmentBanner } from "@features/Appointment/AppointmentBanner/AppointmentBanner";
import { useAppointment } from "@features/Appointment/useAppointment";
import {
    mapBannerSubtitle,
    mapBannerTitle,
    mapButtonLabel,
    mapModalTitle,
    mapTimeSlotLabel,
} from "@features/Appointment/utils";
import { useTranslation } from "react-i18next";
import { AppointmentReschedule } from "@features/Appointment/AppointmentReschedule/AppointmentReschedule";
import { IAppointment } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { KeyedMutator } from "swr";
import { useEffect, useState } from "react";

interface IParams {
    appointmentList: IAppointment[];
    mutate: KeyedMutator<IAppointment[]>;
}

export const Appointment = (props: IParams) => {
    const { appointmentList, mutate } = props;
    const {
        selectedAppointment,
        dateValue,
        setDateValue,
        timeSlotValue,
        setTimeSlotValue,
        handleOpenRescheduleModal,
        handleUpdateAppointment,
        handleCloseRescheduleModal,
        updateAppointmentError,
        isUpdateAppointmentLoading,
    } = useAppointment({ mutate });
    const { t } = useTranslation("appointment");

    const [displayedAppointment, setDisplayedAppointment] = useState<IAppointment>();

    useEffect(() => {
        if (selectedAppointment) {
            setDisplayedAppointment(selectedAppointment);
        }
    }, [selectedAppointment]);

    return (
        <>
            {appointmentList.map((appointment) => (
                <AppointmentBanner
                    appointment={appointment}
                    buttonText={mapButtonLabel(appointment.status, t)}
                    date={appointment.scheduledDate}
                    key={appointment.id}
                    slot={mapTimeSlotLabel(appointment.timeSlot)}
                    subTitle={mapBannerSubtitle(appointment.status, t)}
                    title={mapBannerTitle(appointment, t)}
                    onClick={() => handleOpenRescheduleModal(appointment)}
                />
            ))}
            {displayedAppointment && (
                <AppointmentReschedule
                    appointmentId={displayedAppointment.id}
                    appointmentInstallationType={displayedAppointment.installationType}
                    close={() => handleCloseRescheduleModal()}
                    dateValue={dateValue}
                    isModalOpen={Boolean(selectedAppointment)}
                    isUpdateAppointmentLoading={isUpdateAppointmentLoading}
                    modalTitle={mapModalTitle(displayedAppointment.installationType, t)}
                    setDateValue={setDateValue}
                    setTimeSlotValue={setTimeSlotValue}
                    timeSlotValue={timeSlotValue}
                    updateAppointment={() => handleUpdateAppointment(displayedAppointment)}
                    updateAppointmentError={updateAppointmentError}
                />
            )}
        </>
    );
};
